/* Curated PDP product comparison.
   Alternatives are rendered server-side from custom.related_products so this script
   never scrapes descriptions or asserts product facts it does not have. */
(function () {
  'use strict';

  function dataFrom(node, prefix) {
    return {
      title: node.dataset[prefix + 'Title'] || '',
      image: node.dataset[prefix + 'Image'] || '',
      price: node.dataset[prefix + 'Price'] || '',
      condition: node.dataset[prefix + 'Condition'] || '',
      dimensions: node.dataset[prefix + 'Dimensions'] || '',
      warranty: node.dataset[prefix + 'Warranty'] || '',
      shipTime: node.dataset[prefix + 'ShipTime'] || '',
      variantId: node.dataset[prefix + 'VariantId'] || '',
      variants: Number(node.dataset[prefix + 'Variants'] || 0),
      url: node.dataset[prefix + 'Url'] || ''
    };
  }

  function make(tag, className, text) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  }

  function productCard(product, role, current) {
    var card = make('section', 'cp-compare__machine');
    card.setAttribute('aria-label', role + ': ' + product.title);
    if (product.image) {
      var image = make('img', 'cp-compare__image');
      image.src = product.image;
      image.alt = '';
      image.width = 180;
      image.height = 180;
      image.loading = 'lazy';
      card.appendChild(image);
    }
    card.appendChild(make('span', 'cp-compare__machine-label', role));
    card.appendChild(make('h3', 'cp-compare__machine-title', product.title));
    card.appendChild(make('p', 'cp-compare__price', product.price || 'Price shown on product page'));
    return card;
  }

  function factRow(label, left, right) {
    var row = make('div', 'cp-compare__fact');
    row.appendChild(make('span', 'cp-compare__fact-label', label));
    row.appendChild(make('span', 'cp-compare__fact-value', left || 'Not listed'));
    row.appendChild(make('span', 'cp-compare__fact-value', right || 'Not listed'));
    return row;
  }

  function activeVariantId(root, fallback) {
    var selected = document.querySelector('form[action*="/cart/add"] [name="id"]:not([disabled])');
    return selected && selected.value ? selected.value : fallback;
  }

  function addToCart(button, variantId) {
    if (!variantId) return;
    var original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart add failed');
      return response.json();
    }).then(function () {
      button.textContent = 'Added to cart';
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      window.setTimeout(function () {
        button.textContent = original;
        button.disabled = false;
      }, 1700);
    }).catch(function () {
      button.textContent = 'Try again';
      button.disabled = false;
    });
  }

  function actionFor(product, current) {
    if (!current && product.variants > 1) {
      var link = make('a', 'cp-compare__cart-btn cp-compare__cart-btn--secondary', 'Choose options');
      link.href = product.url;
      return link;
    }
    var button = make('button', 'cp-compare__cart-btn', 'Add to cart');
    button.type = 'button';
    button.addEventListener('click', function () {
      addToCart(button, current ? activeVariantId(document, product.variantId) : product.variantId);
    });
    return button;
  }

  function renderComparison(root, alternate) {
    var current = dataFrom(root, 'current');
    var results = root.querySelector('[data-ctx-compare-results]');
    var chooser = root.querySelector('[data-ctx-compare-chooser]');
    results.textContent = '';

    var heading = make('div', 'cp-compare__result-heading');
    var back = make('button', 'cp-compare__back', '‹ Choose a different machine');
    back.type = 'button';
    back.addEventListener('click', function () {
      results.hidden = true;
      chooser.hidden = false;
    });
    heading.appendChild(back);
    heading.appendChild(make('p', '', 'Comparison is limited to verified product facts.'));
    results.appendChild(heading);

    var machines = make('div', 'cp-compare__machines');
    machines.appendChild(productCard(current, 'Current choice', true));
    machines.appendChild(productCard(alternate, 'Compare against', false));
    results.appendChild(machines);

    var facts = make('div', 'cp-compare__facts');
    facts.appendChild(factRow('Price', current.price, alternate.price));
    facts.appendChild(factRow('Condition', current.condition, alternate.condition));
    facts.appendChild(factRow('Dimensions', current.dimensions, alternate.dimensions));
    facts.appendChild(factRow('Warranty', current.warranty, alternate.warranty));
    facts.appendChild(factRow('Lead time', current.shipTime, alternate.shipTime));
    results.appendChild(facts);

    var actions = make('div', 'cp-compare__actions');
    actions.appendChild(actionFor(current, true));
    actions.appendChild(actionFor(alternate, false));
    var cart = make('a', 'cp-compare__view-cart', 'View cart');
    cart.href = '/cart';
    actions.appendChild(cart);
    results.appendChild(actions);

    chooser.hidden = true;
    results.hidden = false;
  }

  document.addEventListener('click', function (event) {
    var open = event.target.closest('[data-ctx-compare-open]');
    if (open) {
      var openRoot = open.closest('[data-ctx-compare]');
      var dialog = openRoot && openRoot.querySelector('[data-ctx-compare-dialog]');
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }

    var close = event.target.closest('[data-ctx-compare-close]');
    if (close) {
      var closeDialog = close.closest('dialog');
      if (closeDialog) closeDialog.close();
      return;
    }

    var option = event.target.closest('[data-ctx-compare-option]');
    if (option) {
      var root = option.closest('[data-ctx-compare]');
      if (root) renderComparison(root, {
        title: option.dataset.title || '', image: option.dataset.image || '', price: option.dataset.price || '',
        condition: option.dataset.condition || '', dimensions: option.dataset.dimensions || '',
        warranty: option.dataset.warranty || '', shipTime: option.dataset.shipTime || '',
        variantId: option.dataset.variantId || '', variants: Number(option.dataset.variants || 0), url: option.dataset.url || ''
      });
    }
  });

  document.addEventListener('click', function (event) {
    var dialog = event.target;
    if (dialog && dialog.matches && dialog.matches('[data-ctx-compare-dialog]') && event.target === dialog) dialog.close();
  });
}());
